var env = {}
env.local = {
	mode: 'local',
	ApiURL: 'https://api.subiz.net/4.0',
	WsURL: 'wss://ws-0.subiz.net/ws',
	numWSServer: 10,
	BaseURL: '//localhost:8081',
	SentryDSN: '',
	FileURL: 'https://filev4.subiz.net',
	FirebaseSenderID: '168786705379',
	FirebaseProjectID: 'subiz-v4-dev',
	FirebasePublicVapidKey: 'BKGMp7VZh3IRbYLqQZNblOVbyxwAVnf7Vzhj5pIL1SjiDHqh8WAtt1n9nvwVG_XzELLrtbesTZ8pjzGJQM4bBcs',
	BackendURL: 'https://widget-4.subiz.net',
	PublicPath: 'https://public-gcs.subiz-cdn.com/widget-v4/dev',
	GGClientID: '457995922934-6gnb7ku5ck1a9v923jrcbtmjq8ffe31b.apps.googleusercontent.com',
	GGCallbackURL: 'https://widgetv4.subiz.net/v4/google-callback',
	FBAppID: '521984397965108',
	FBCallbackURL: 'https://widgetv4.subiz.net/v4/facebook-callback',
}

env.dev = {
	mode: 'dev',
	ApiURL: 'https://api.subiz.net/4.0',
	WsURL: 'wss://ws-0.subiz.net/ws',
	numWSServer: 10,
	BaseURL: 'https://widgetv4.subiz.net',
	SentryDSN: '',
	FileURL: 'https://filev4.subiz.net',
	FirebaseSenderID: '168786705379',
	FirebaseProjectID: 'subiz-v4-dev',
	FirebasePublicVapidKey: 'BKGMp7VZh3IRbYLqQZNblOVbyxwAVnf7Vzhj5pIL1SjiDHqh8WAtt1n9nvwVG_XzELLrtbesTZ8pjzGJQM4bBcs',
	BackendURL: 'https://widget-4.subiz.net',
	PublicPath: 'https://public-gcs.subiz-cdn.com/widget-v4/dev',
	GGClientID: '457995922934-6gnb7ku5ck1a9v923jrcbtmjq8ffe31b.apps.googleusercontent.com',
	GGCallbackURL: 'https://widgetv4.subiz.net/v4/google-callback',
	FBAppID: '521984397965108',
	FBCallbackURL: 'https://widgetv4.subiz.net/v4/facebook-callback',
}

env.prod = {
	mode: 'prod',
	ApiURL: 'https://apiv4.subiz.com/4.0',
	WsURL: 'wss://ws-0.subiz.com/ws',
	numWSServer: 10,
	BaseURL: 'https://widgetv4.subiz.com',
	SentryDSN: 'https://9e852f76ee93431e917d8ece3f29b466@log.bantin.com/2',
	FileURL: 'https://filev4.subiz.com',
	FirebaseSenderID: '457995922934',
	FirebaseProjectID: 'subiz-servion-4',
	FirebasePublicVapidKey: 'BJ2Rc-0ca5z7EURtkLMAz4l94TvLGU8EuD81vOCGdWuUkjOGPoKwUb3lbZK7JLs09gw0bzWRzkFNnlcriCtO3y4',
	BackendURL: 'https://widget-4.subiz.com',
	PublicPath: 'https://public-gcs.subiz-cdn.com/widget-v4/public/',
	GGClientID: '457995922934-6gnb7ku5ck1a9v923jrcbtmjq8ffe31b.apps.googleusercontent.com',
	GGCallbackURL: 'https://widgetv4.subiz.com/v4/google-callback',
	FBAppID: '521984397965108',
	FBCallbackURL: 'https://widgetv4.subiz.com/v4/facebook-callback',
}

module.exports = env[(process && process.env.VUE_APP_ENVIRONMENT) || 'local']
